import { Component, ChangeDetectionStrategy } from '@angular/core';

import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { LoggerService } from '../../services/logger.service';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideMail, lucideTriangleAlert } from '@ng-icons/lucide';
import { HlmAlertImports } from '@spartan-ng/helm/alert';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmCardImports } from '@spartan-ng/helm/card';
import { HlmFieldImports } from '@spartan-ng/helm/field';
import { HlmInputImports } from '@spartan-ng/helm/input';
import { HlmSpinnerImports } from '@spartan-ng/helm/spinner';
import { LogoComponent } from '../../components/logo/logo.component';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  templateUrl: './forgot-password.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ReactiveFormsModule,
    RouterModule,
    NgIcon,
    HlmAlertImports,
    HlmButtonImports,
    HlmCardImports,
    HlmFieldImports,
    HlmInputImports,
    HlmSpinnerImports,
    LogoComponent,
  ],
  providers: [provideIcons({ lucideMail, lucideTriangleAlert })],
})
export class ForgotPasswordComponent {
  resetForm: FormGroup;
  submitted = false;
  loading = false;
  success = false;
  error = '';

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private logger: LoggerService,
  ) {
    this.resetForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  get f() {
    return this.resetForm.controls;
  }

  async onSubmit() {
    this.submitted = true;
    this.error = '';

    if (this.resetForm.invalid) {
      return;
    }

    this.loading = true;

    try {
      await lastValueFrom(this.authService.requestPasswordReset(this.resetForm.value.email));
      this.success = true;
    } catch (error) {
      this.logger.error(error);
      this.error = 'Ein Fehler ist aufgetreten. Bitte versuche es später erneut.';
    } finally {
      this.loading = false;
    }
  }
}
